var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selector px-2",attrs:{"items":_vm.languages,"label":"Langue du formulaire","item-text":"title","item-value":"value"},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }